module.exports = __webpack_public_path__ + "static/media/8a86ee62.jpg";